import React, { Component } from 'react'
import { func, bool, string } from 'prop-types'
import { SelectGardenerModal } from '../../modals/SelectGardenerModal'
import { translate } from 'react-i18next'

class SelectGardenerButtonComponent extends Component {
  constructor () {
    super()
    this.state = { open: false }
  }

  closeModal () {
    this.setState({ open: false })
  }

  openModal () {
    this.setState({ open: true })
  }

  render () {
    const { t, disabled, id, name, onSubmit, hidden, text } = this.props

    if (hidden) {
      return (<span />)
    }

    return (
      <div>
        <button
          onClick={() => !disabled && this.openModal()}
          className={`${disabled ? 'btn--disabled' : 'btn--green'} demandes__button`}
          disabled={disabled}>{text || t('common:jardiniers:button_choose')}</button>
        <SelectGardenerModal
          isOpen={this.state.open}
          handleClose={() => this.closeModal()}
          onSubmit={onSubmit}
          id={id}
          name={name}
        />
      </div>
    )
  }
}

SelectGardenerButtonComponent.propTypes = {
  t: func,
  disabled: bool,
  hidden: bool,
  onSubmit: func,
  id: string,
  name: string
}

export const SelectGardenerButton = translate()(SelectGardenerButtonComponent)



// WEBPACK FOOTER //
// ./src/components/ui/buttons/SelectGardenerButton.js